/* @refresh reload */
import '@/sentry'
import { runEngineSmokeTest } from './engine_test'
import { render } from 'solid-js/web'
import routerFunction from "./router"
import './sass/index.sass'

const root = document.getElementById('root') as HTMLElement

render(routerFunction, root)

if (import.meta.env.VITE_RUN_ENGINE_SMOKE_TEST === 'true') {
  void runEngineSmokeTest().catch((error) => console.error('[engine-test]', error))
}
